import store from '@/store';
import ManagerService from '@/api/ManagerService';
import APIService from '@/api';

import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import {
  removeMerchantMeetingOboardingState,
  setMerchantInviteState
} from '../router-utils';
import { OnboardingURL, getSignUpUrlRoutes } from '@/views/Onboarding/helpers';
import flagKeys from '@/constants/flagKeys';

const managerService = new ManagerService();

class InviteMerchantRedirect {
  constructor(
    private readonly to: MiddlewareRoute,
    private readonly from: MiddlewareRoute,
    private readonly next: MiddlewareCallback
  ) {}

  get flags() {
    return store.getters['flags/getFlags'] || [];
  }

  get isFeatureFlagLoginHandleActive() {
    return this.flags.includes(flagKeys.dashboardBusinessOwnershipLoginHandle);
  }

  handleInviteOwner() {
    const route = getSignUpUrlRoutes() as typeof OnboardingURL;
    return this.next({
      path: route.INVITATION_MERCHANT_SIGNUP
    });
  }

  handleInviteOwnerWithAccount(managerType: string) {
    const route = getSignUpUrlRoutes() as typeof OnboardingURL;
    return this.next({
      path: route.INVITATION_MERCHANT_SIGNUP_LOGIN,
      query: {
        utm_source: 'hubspot-merchant-invite',
        managerType
      }
    });
  }

  handleInvite() {
    (async () => {
      const inviteCode = this.to.params.code;

      try {
        const { data } = await managerService.getBusinessInfo(inviteCode);

        if (data.status && data.status !== 'pending-claim') {
          this.next('/');

          return;
        }

        setMerchantInviteState({
          ...data,
          inviteCode
        });

        removeMerchantMeetingOboardingState();

        if (
          data.isManagerAlreadyRegistered &&
          this.isFeatureFlagLoginHandleActive
        ) {
          APIService.resetCredentials(() => {});
          this.handleInviteOwnerWithAccount(data.managerType);
          return;
        }

        this.handleInviteOwner();
      } catch (err) {
        this.next({ name: 'manager-invitation-not-found' });
      }
    })();
  }

  async execute() {
    this.handleInvite();
  }
}
export class HandleInviteMerchantRedirect implements IRouterMiddleware {
  canActivate(to: MiddlewareRoute): boolean {
    return ['merchant-invitation'].includes(to.name!) && !!to.params.code;
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    const instance = new InviteMerchantRedirect(to, from, next);
    instance.execute();
  }
}
